(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-root]').forEach((root) => {
      if (root.dataset.salePriceReady) return;
      root.dataset.salePriceReady = 'true';
      root.addEventListener('iurop:variant-change', (event) => {
        const target = root.querySelector('[data-product-compare-price]');
        if (!target) return;
        const { variant, cents, sellingPlan } = event.detail || {};
        const allocation = sellingPlan
          ? variant?.selling_plan_allocations?.find((item) => String(item.selling_plan_id) === String(sellingPlan))
          : null;
        const previous = Number(allocation?.compare_at_price ?? variant?.compare_at_price) || 0;
        target.hidden = !(previous > Number(cents));
        if (target.hidden) {
          target.textContent = '';
          return;
        }
        const locale = document.documentElement.lang || 'es-ES';
        const currency = root.dataset.currency || 'EUR';
        target.textContent = currency === 'EUR'
          ? new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(previous / 100) + ' €'
          : new Intl.NumberFormat(locale, { style: 'currency', currency }).format(previous / 100);
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
